import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'fslightbox'

import initGlobal, { initPageHeader, initPageFooter } from '@bikemap/js/integrations/global'
import { initRelatedSection, injectAnchorRel, injectDeepLinks } from './seo'
import { initUserInspiration } from './user-inspiration'
import {
    initAllImagesButton,
    initFavoriteButton,
    initShareButton,
} from './functionality.jsx'
import { initSpamManagement } from './spam-management.jsx'

// SEO
injectAnchorRel()
injectDeepLinks()
initRelatedSection()

// Global layout
initGlobal()
initPageHeader()
initPageFooter()

// CTA banner
initUserInspiration()

// Feature functionality
initFavoriteButton()
initShareButton()
initAllImagesButton()

// Staff functionality
initSpamManagement()
